import m from "mithril";
import svglist from "./svglist";

export default () => {
	return {
		view: (v) => {
			let svgplan = svglist[v.attrs.name];
			if (!svgplan)
				svgplan = m("rect", {
					x: "3",
					y: "3",
					width: "18",
					height: "18",
					rx: "2",
					ry: "2",
				});

			// return null;

			return m(
				"svg",
				{
					xmlns: "http://www.w3.org/2000/svg",
					width: "1.2em",
					height: "1.2em",
					viewBox: "0 0 24 24",
					fill: "none",
					"stroke-width": "2",
					"stroke-linecap": "square",
					"stroke-linejoin": "arcs",
				},
				svgplan
			);
		},
	};
};
